import { useState } from 'react';
import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';

const Photos = () => {
  const { t } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);

  const photos = [
    { id: 1,  url: '/photo-site/exterieur/IMG_0351.jpeg',  title: 'La Marmotte Joyeuse : Façade Est', alt: 'La Marmotte Joyeuse : Façade Est' },
    { id: 2,  url: '/photo-site/exterieur/IMG_1094.jpeg',  title: 'Vue de l’église : Le glacier', alt: 'Vue de l’église : Le glacier' },
    { id: 3,  url: '/photo-site/exterieur/IMG_1095.jpeg',  title: 'Vue de l’église : Le village', alt: 'Vue de l’église : Le village' },
    { id: 4,  url: '/photo-site/exterieur/IMG_1096.jpeg',  title: 'Vue de l’église : La Marmotte Joyeuse', alt: 'Vue de l’église : La Marmotte Joyeuse' },
    { id: 5,  url: '/photo-site/exterieur/IMG_1534.jpeg',  title: 'La Meije depuis le GR 56', alt: 'La Meije depuis le GR 56' },
    { id: 6,  url: '/photo-site/exterieur/IMG_2432.jpeg',  title: 'Lac de montagne', alt: 'Lac de montagne' },
    { id: 7,  url: '/photo-site/exterieur/IMG_4549.jpeg',  title: 'Paysage montagnard', alt: 'Paysage montagnard' },
    { id: 8,  url: '/photo-site/exterieur/IMG_7765.jpeg',  title: 'Vue du Village : le glacier', alt: 'Vue du Village : le glacier' },
    { id: 9,  url: '/photo-site/exterieur/IMG_4555.jpeg',  title: 'Paysage montagnard', alt: 'Paysage montagnard' },
    { id: 10, url: '/photo-site/exterieur/IMG_4556.jpeg',  title: 'Paysage montagnard', alt: 'Paysage montagnard' },
    { id: 11, url: '/photo-site/exterieur/IMG_4580.jpeg',  title: 'La Marmotte Joyeuse : Façade Ouest', alt: 'La Marmotte Joyeuse : Façade Ouest' },
    { id: 12, url: '/photo-site/exterieur/IMG_4584.jpeg',  title: 'La Grave : Alentour', alt: 'La Grave : Alentour' },
    { id: 13, url: '/photo-site/exterieur/IMG_4589.jpeg',  title: 'Paysage montagnard', alt: 'Paysage montagnard' },
    { id: 14, url: '/photo-site/exterieur/IMG_6305.jpeg',  title: 'La Marmotte Joyeuse : Façade Nord en hiver', alt: 'La Marmotte Joyeuse : Façade Nord en hiver' },
    { id: 15, url: '/photo-site/exterieur/IMG_6309.jpeg',  title: 'La Marmotte Joyeuse : Façade Est en hiver', alt: 'La Marmotte Joyeuse : Façade Est en hiver' },
    { id: 16, url: '/photo-site/exterieur/IMG_6324.jpeg',  title: 'La Marmotte Joyeuse : La Façade Ouest en hiver', alt: 'La Marmotte Joyeuse : La Façade Ouest en hiver' },
    { id: 17, url: '/photo-site/exterieur/IMG_6623.jpeg',  title: 'L’église classée : En hiver', alt: 'L’église classée : En hiver' },
    { id: 18, url: '/photo-site/exterieur/IMG_6781.jpeg',  title: 'Vue des Terrasses', alt: 'Vue des Terrasses' },
    { id: 19, url: '/photo-site/exterieur/IMG_6810.jpeg',  title: 'Gite du Chancel', alt: 'Gite du Chancel' },
    { id: 20, url: '/photo-site/exterieur/IMG_6811.jpeg',  title: 'Lac du Puy Vachier', alt: 'Lac du Puy Vachier' },
    { id: 21, url: '/photo-site/exterieur/IMG_6822b.jpeg', title: 'Paysage montagnard', alt: 'Paysage montagnard' },
    { id: 22, url: '/photo-site/exterieur/IMG_6825.jpeg',  title: 'Paysage montagnard', alt: 'Paysage montagnard' },
    { id: 23, url: '/photo-site/exterieur/IMG_7226.jpeg',  title: 'La Marmotte Joyeuse : Angle Nord Est', alt: 'La Marmotte Joyeuse : Angle Nord Est' },
    { id: 24, url: '/photo-site/exterieur/IMG_7231.jpeg',  title: 'La Marmotte Joyeuse : Vue du balcon d’Epidote', alt: 'La Marmotte Joyeuse : Vue du balcon d’Epidote' },
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ImageGallery",
    "name": "Album Photos La Marmotte Joyeuse",
    "description": "Découvrez en images nos appartements et les magnifiques paysages des Alpes françaises depuis La Marmotte Joyeuse.",
    "image": photos.map(photo => ({
      "@type": "ImageObject",
      "url": `https://marmottejoyeuse.fr${photo.url}`,
      "name": photo.title,
      "description": photo.alt
    }))
  };

  return (
    <>
      <SEO
        title={t('seo.photos.title')}
        description={t('seo.photos.description')}
        keywords="photos la grave, galerie alpes, images hébergement, photos appartement, paysage montagne, marmotte joyeuse photos"
        url="/photos"
        structuredData={structuredData}
      />
      <div className="container mx-auto px-4 pt-28 pb-16 min-h-screen">
        <h1 className="text-4xl font-bold mb-8 text-center">{t('photos.title')}</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {photos.map((photo) => (
          <div 
            key={photo.id}
            className="group relative aspect-square overflow-hidden rounded-xl cursor-pointer"
            onClick={() => setSelectedImage(photo)}
          >
            <img 
              src={photo.url}
              alt={photo.alt}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              loading="lazy"
              width="400"
              height="400"
            />
            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <p className="text-white text-lg font-semibold text-center p-4">
                {photo.title}
              </p>
            </div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-4xl w-full">
            <img 
              src={selectedImage.url}
              alt={selectedImage.alt}
              className="w-full h-auto rounded-xl"
              loading="lazy"
            />
            <p className="absolute bottom-4 left-4 text-white text-xl font-semibold">
              {selectedImage.title}
            </p>
            <button 
              className="absolute top-4 right-4 text-white text-xl font-bold bg-black/50 w-10 h-10 rounded-full hover:bg-black/75 transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImage(null);
              }}
            >
              ×
            </button>
          </div>
        </div>
      )}
      </div>
    </>
  );
};

export default Photos;
